import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {PagerDataObject} from "../../entities/pagerDataObject";
import {Subject} from "rxjs";
import {SharedService} from "../../services/sharedService";
import {AuthService} from "../../services/auth.service";
import {ReportService} from "../../services/report.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-report-list',
    templateUrl: './report-list.component.html',
    standalone: false
})
export class ReportListComponent implements OnDestroy, OnInit {
    reports: any
    columns: Array<any>;
    data: PagerDataObject[] = [];
    @Input()
    disableHeader = false;
    subscription = [];
    private dataSub$: Subject<any>[] = [];
    query: String;
    user

    ngOnInit() {
        this.sharedService.loadMenuItems("report");
        this.auth.getCurrentUser().subscribe(user => {
            this.user = user
            this.loadReports();
        })
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.forEach(sub => sub.unsubscribe());
        }
    }

    constructor(private reportService: ReportService,
                private sharedService: SharedService,
                private auth: AuthService,
                private router: Router) {
    }

    onGridQuery(query) {
        this.query = query.query + "&year=" + query.extraParameter
        if (this.dataSub$[query.extraParameter] !== undefined)
            this.dataSub$[query.extraParameter].next(this.query);
    }

    delete(id) {
        const confirm = window.confirm(`Are you sure to delete Report #${id}?`)
        if (confirm) {
            this.reportService.delete(id)
                .subscribe(report => {
                    this.loadReports()
                });
        }
    }

    loadReports() {
        this.reportService.getReportList().subscribe(list => {
            this.reports = list;
        });
    }

    reportView(id: any) {
        this.router.navigate(["/report/" + id]);
    }

    getGradient(index: number): string {
        const gradients = [
            'linear-gradient(135deg, #0d6efd, #6610f2)',
            'linear-gradient(135deg, #198754, #20c997)',
            'linear-gradient(135deg, #fd7e14, #ffc107)',
            'linear-gradient(135deg, #e83e8c, #dc3545)',
        ];
        return gradients[index % gradients.length];
    }
}
